import {
  addListener,
  createListenerMiddleware,
  TypedAddListener,
  TypedStartListening,
} from '@reduxjs/toolkit'
import type { AppDispatch, RootState } from './store'
import { webAppThunkExtra, WebAppThunkExtraType } from './thunkExtra'

export const listenerMiddleware = createListenerMiddleware({
  extra: webAppThunkExtra,
})

export type AppStartListening = TypedStartListening<
  RootState,
  AppDispatch,
  WebAppThunkExtraType
>

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening

export const addAppListener = addListener as TypedAddListener<
  RootState,
  AppDispatch,
  WebAppThunkExtraType
>
